import { RefObject } from 'react';
import WaveSurfer from 'wavesurfer.js';
import { create } from 'zustand';
import { formatTime } from '@/helpers/formatTime';

interface AudioState {
  wavesurfer: WaveSurfer | null;
  setWavesurfer: (wavesurfer: WaveSurfer) => void;
  setWavesurferCurrentTime: () => void;
  setProgressCurrentTime: (time: number) => void;
  progressRef: RefObject<HTMLInputElement> | null;
  setProgressRef: (ref: RefObject<HTMLInputElement>) => void;
  currentTime: string;
  setCurrentTime: (time: string) => void;
  remainingTime: string;
  setRemainingTime: (time: string) => void;
  setProgressTime: () => void;
  duration: number;
  setDuration: (duration: number) => void;
  currentWidth: string;
  setCurrentWidth: () => void;
}

export const useAudioStore = create<AudioState>((set) => ({
  wavesurfer: null,
  setWavesurfer: (wavesurfer) => set({ wavesurfer }),
  setWavesurferCurrentTime: () =>
    set((state) => {
      if (state.wavesurfer && state.progressRef?.current) {
        const value = state.progressRef.current.value;
        state.wavesurfer.seekTo(Number(value) / state.duration);
      }
      return {};
    }),
  progressRef: null,
  setProgressRef: (ref) => set({ progressRef: ref }),
  setProgressCurrentTime: (time) =>
    set((state) => {
      if (state.progressRef?.current) {
        state.progressRef.current.value = time.toString();
      }
      return {};
    }),
  currentTime: '00:00',
  setCurrentTime: (time) => set({ currentTime: time }),
  remainingTime: '-00:00',
  setRemainingTime: (time) => set({ remainingTime: time }),
  setProgressTime: () =>
    set((state) => {
      if (state.progressRef?.current) {
        const currentTime = Number(state.progressRef.current.value);
        const duration = Number(state.progressRef.current.max);
        const timeLeft = duration - currentTime;

        state.setCurrentTime(formatTime(currentTime));
        state.setRemainingTime(`-${formatTime(timeLeft)}`);
      }
      return {};
    }),
  duration: 0,
  setDuration: (duration) => set({ duration }),
  currentWidth: '',
  setCurrentWidth: () =>
    set((state) => {
      if (state.progressRef?.current) {
        const time = Number(state.progressRef.current.value);
        state.currentWidth = `${(time / state.duration) * 100}%`;
      }
      return {};
    }),
}));

export default useAudioStore;
